'use strict';

var novicell = novicell || {};

novicell.newslistShowAll = novicell.newslistShowAll || function () {
    
    function init() {
        var showAllButton = document.querySelectorAll('.o-news-list__btnShowAllFunction');
        if(showAllButton.length){
            for(var i = 0 ; i < showAllButton.length ; i++){
                showAllButton[i].addEventListener('click',function(e){
                    e.preventDefault();
                    var containingBlock = novicell.helpers.closestByClass(this, 'o-news-list');
                    if(containingBlock != null){
                        containingBlock.classList.add('o-news-list--showAllTriggered');
                    }
                });
            }
        }
    }
    
    return {
        init: init
    };
    
}();
